import { MasterDetailListEntry } from '@sdbn/common';
import { RoutingRulePosition } from './routing-rule-position';

export class RoutingRule implements MasterDetailListEntry {

    id: number;
    name: string;
    transportOptionId: number;
    positions: RoutingRulePosition[] = [];
    deletedPositions: RoutingRulePosition[] = [];
    sortOrder: string;

    constructor(routingRule: any) {
        this.id = routingRule.id;
        this.name = routingRule.name;
        this.transportOptionId = routingRule.transportOptionId;
        this.positions = routingRule.positions;
        this.deletedPositions = routingRule.deletedPositions;
        this.sortOrder = routingRule.sortOrder;
    }

    public get listTitle(): string {
        return this.name;
    }

    public get listTitleDictionaryKey(): string {
        return null;
    }

    public get listSubTitle(): string {
        return null;
    }

    public get groupIdentifier(): String {
      return null;
    }

    public get childs() : Array<MasterDetailListEntry> {
      return null;
    }
}
